module.exports = __webpack_public_path__ + "static/media/gray_04.be1d4ff2.jpg";